/**
 * Date helpers for the accounting module — thin wrappers over the shared
 * dayjs instance (`@/shared/lib/dayjs`, already locale-configured). dayjs only,
 * never moment / date-fns (hard rule).
 *
 * The wire format is ISO ("2026-05-16"); display format is "DD MMM, YYYY"
 * localised via the active dayjs locale. The prototype's Cyrillic display
 * dates ("16 май, 2026") are converted to ISO at MSW seed time (see the seed
 * module), not here — this lib only formats ISO → display and back.
 */

import { dayjs } from '@/shared/lib/dayjs'

/** Any → ISO date "YYYY-MM-DD" (wire format). */
export function toISODate(value: dayjs.ConfigType): string {
  return dayjs(value).format('YYYY-MM-DD')
}

/** ISO → localised display "DD MMM, YYYY". */
export function formatDisplayDate(iso: string): string {
  return dayjs(iso).format('DD MMM, YYYY')
}

/** ISO datetime → localised display "DD MMM, YYYY HH:mm". */
export function formatDisplayDateTime(iso: string): string {
  return dayjs(iso).format('DD MMM, YYYY HH:mm')
}
